
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const EnvelopeIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10 67.5C10 73.299 14.701 78 20.5 78H75.5C81.299 78 86 73.299 86 67.5V28.5C86 26.8796 85.633 25.345 84.9775 23.9747L85.0102 23.941L84.9171 23.8506C83.2023 20.3839 79.6295 18 75.5 18H20.5C16.3702 18 12.7972 20.3843 11.0825 23.8514L10.9902 23.941L11.0227 23.9744C10.3671 25.3448 10 26.8795 10 28.5V67.5ZM17 30.125V67.5C17 69.433 18.567 71 20.5 71H75.5C77.433 71 79 69.433 79 67.5V30.1254L55.5301 54.2756C51.4067 58.5185 44.5937 58.5185 40.4703 54.2756L17 30.125ZM74.22 25H21.7804L45.4902 49.3971C46.8647 50.8114 49.1357 50.8114 50.5102 49.397L74.22 25Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.5 74.5C16.634 74.5 13.5 71.366 13.5 67.5V28.5C13.5 24.634 16.634 21.5 20.5 21.5H75.5C79.366 21.5 82.5 24.634 82.5 28.5V67.5C82.5 71.366 79.366 74.5 75.5 74.5H20.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10 67.5C10 73.299 14.701 78 20.5 78H75.5C81.299 78 86 73.299 86 67.5V28.5C86 26.8796 85.633 25.345 84.9775 23.9747L85.0102 23.941L84.9171 23.8506C83.2023 20.3839 79.6295 18 75.5 18H20.5C16.3702 18 12.7972 20.3843 11.0825 23.8514L10.9902 23.941L11.0227 23.9744C10.3671 25.3448 10 26.8795 10 28.5V67.5ZM17 30.125V67.5C17 69.433 18.567 71 20.5 71H75.5C77.433 71 79 69.433 79 67.5V30.1254L55.5301 54.2756C51.4067 58.5185 44.5937 58.5185 40.4703 54.2756L17 30.125ZM74.22 25H21.7804L45.4902 49.3971C46.8647 50.8114 49.1357 50.8114 50.5102 49.397L74.22 25Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.5 74.5C16.634 74.5 13.5 71.366 13.5 67.5V28.5C13.5 24.634 16.634 21.5 20.5 21.5H75.5C79.366 21.5 82.5 24.634 82.5 28.5V67.5C82.5 71.366 79.366 74.5 75.5 74.5H20.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
